import type { DelayTimes } from '@/components/video_list/types';

export const DELAY_CONFIG: DelayTimes = {
    HOVER: 200,
    SCROLL: 500,
    TIMEOUT: 500,
    PLAY: 1000,
};
